// Simple wrapper to expose ready function for use in block js files

import { ready } from 'formstone/utils';

window.SiteReady = (cb) => {
  // console.log(cb);
  ready(() => {
    console.log('Ready');
    cb(jQuery);
  });
};